<ng-container *transloco="let convert;">
  <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
    <app-modal class="existing-modal-container" [modalId]="id">
      <div class="modal-close-container">
        <button
          id="existing-photo-close"
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          (click)="close()"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
      <ng-container>
        <ng-container>
          <header class="modal__header mb-4 d-block">
            <h1 class="modal__title mb-0 fw-bold" tabindex="-1">
              {{convert('sellModule.posting.existingPhotos.textExistingPhotos')}}
            </h1>
            <div class="content-card-subtitle mt-2">{{convert('sellModule.posting.existingPhotos.textSelectFive')}}</div>
          </header>
          <div class="modal__content">
            <div class="modal__body">
              <div class="existing-image-list">
                @if (photoList?.length) {
                  <div class="existing-image-grid">
                    @for (photoItem of photoList; track photoItem; let i = $index) {
                      <div class="existing-image-container"
                        (click)="selectExistingPhotos(i)"
                        [ngClass]="{'selected-existing-photos': photoItem.isExistingImage}"
                        >
                        <img [src]="photoItem.url || photoItem.sourceUrl" alt="image-{{i}}">
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="modal__actions mt-4">
                <button
                  class="btn btn-primary mb-3 mb-md-0"
                  data-track-elem="button"
                  data-track-name="Use Existing Photos"
                  [attr.aria-label]="convert('sellModule.posting.existingPhotos.ariaLabelUseExPhoto')"
                  (click)="sendSelectedPhotos()"
                  >
                  {{convert('sellModule.posting.existingPhotos.ariaLabelUseExPhoto')}}
                </button>
                <button
                  class="btn btn-link cancel-btn me-md-2"
                  data-track-elem="button"
                  data-track-name="Cancel"
                  [attr.aria-label]="convert('common.btnCancel')"
                  (click)="close()"
                  >
                  {{convert('common.btnCancel')}}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </app-modal>
  </trap-focus>
</ng-container>
